<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div *ngIf="!responseLoader">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb" [hidden]="!responseLoader">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Inventory</a></li>
        </ul>
      </div>
      <!-- breadcrumb End -->

      <!-- START BASIC TABLE SAMPLE -->
      <div class="block" [hidden]="!responseLoader">
        <div class="page-header">
          <span class="page-header__title">Device Inventory</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!responseLoader ? getLocationData() : null"/>
        </div>

        <!-- Filter Row -->
        <div class="Reports_form_div">
          <div class="row align-items-center">
            <div class="col-md-6 col-xs-12">
              <mat-form-field appearance="outline" class="w-100 density-compact">
                <mat-label>Location</mat-label>
                <mat-select [(ngModel)]="selectedLocation" (selectionChange)="locationChangeData(selectedLocation)">
                  <mat-option value="All">All</mat-option>
                  <mat-option value="Customer">Customer</mat-option>
                  <mat-option value="Inventory">Inventory</mat-option>
                  <mat-option value="Service_Hub">Service Hub</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-xs-12 text-right">
              <div class="search-flex-container" style="float: right;">
                <mat-form-field appearance="outline" class="density-compact search-input-field">
                  <mat-label>Search</mat-label>
                  <input matInput (keyup)="searchDevice($event)" [(ngModel)]="search" autocomplete="off" placeholder="Search by device, serial and business name.."/>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <!-- Table Block -->
        <div class="reports_block" *ngIf="responseLoader">
          <div class="table-responsive" id="zoomView" *ngIf="displayAquDeviceOnHand && displayAquDeviceOnHand.length > 0">
            <table class="table table-striped table-bordered table-hover text-centre">
              <thead class="onhandheading">
                <tr>
                  <th>S.No</th>
                  <th>AQU Device Number</th>
                  <th>AQU Serial Number</th>
                  <th>TINTO Device Number</th>
                  <th>TINTO Serial Number</th>
                  <th>Location</th>
                  <th>Details</th>
                  <th>Date</th>
                  <th class="actionstyle">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let list of displayAquDeviceOnHand; let i = index">
                  <td>{{i + 1}}</td>
                  <td>{{list && list.device && list.device.number}}</td>
                  <td>{{list && list.device && list.device.serial_number}}</td>
                  <td colspan="2">
                    <span class="margin-right-10">{{list && list.device && list.device.CustomerDeviceData && list.device.CustomerDeviceData[0] && list.device.CustomerDeviceData[0].calorimeterDevice && list.device.CustomerDeviceData[0].calorimeterDevice.number }}</span>
                    <span class="margin-right-10">{{list && list.device && list.device.CustomerDeviceData && list.device.CustomerDeviceData[0] && list.device.CustomerDeviceData[0].calorimeterDevice && list.device.CustomerDeviceData[0].calorimeterDevice.serial_number}}</span>
                    <div class="buttons-div reports_search_div d-inline-block"
                         *ngIf="(list.device.device_model_id != 3) && (list && list.loc_id != 4) && !(list && list.device && list.device.CustomerDeviceData && list.device.CustomerDeviceData[0] && list.device.CustomerDeviceData[0].calorimeterDevice && list.device.CustomerDeviceData[0].calorimeterDevice.serial_number)">
                      <div class="transactions-button-container" (click)="openAssignTintoPopup(list && list.device_id)">
                        <button type="button" class="transaction-submit-button">
                          <span class="text">Assign</span>
                        </button>
                      </div>
                    </div>
                    <div class="buttons-div reports_search_div d-inline-block"
                         *ngIf="(list && list.device && list.device.CustomerDeviceData && list.device.CustomerDeviceData[0] && list.device.CustomerDeviceData[0].calorimeterDevice && list.device.CustomerDeviceData[0].calorimeterDevice.serial_number)">
                      <div class="transactions-button-container" (click)="getDeviceOnHandDetailsById(list && list.device_id); deAssignTintoDevice()">
                        <button type="button" class="transaction-close-button">
                          <span class="text">De-Assign</span>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>{{list && list.Location_name}}</td>
                  <td *ngIf="(list && list.loc_id == 2) || (list && list.loc_id == 3) || (list && list.loc_id == 4)">
                    {{list && list.DeviceMovementData && list.DeviceMovementData.to}}</td>
                  <td *ngIf="(list && list.loc_id == 1)">
                    {{list.BusinessEntites?.[0]?.businessName}}</td>
                  <td>{{list && list.DeviceMovementData && list.DeviceMovementData.date | date:"dd-MMM-yyyy"}}</td>
                  <td>
                    <!--Customer location type-->
                    <div class="buttons-div reports_search_div d-inline-block margin-right-10" *ngIf="list && list.loc_id == 1">
                      <div class="transactions-button-container" (click)="getDeviceDetailsById(list && list.device_id); closePopups(); showDeassignPopup = true">
                        <button type="button" class="transaction-close-button">
                          <span class="text">De-Assign</span>
                        </button>
                      </div>
                    </div>
                    <div class="buttons-div reports_search_div d-inline-block" *ngIf="list && list.loc_id == 1">
                      <div class="transactions-button-container" (click)="getDeviceDetailsById(list && list.device_id); closePopups(); showCustomerInactivePopup = true">
                        <button type="button" class="transaction-close-button">
                          <span class="text">In-Active</span>
                        </button>
                      </div>
                    </div>
                    <!--Inventory location type-->
                    <div class="buttons-div reports_search_div d-inline-block margin-right-10" *ngIf="list && list.loc_id == 2">
                      <div class="transactions-button-container" (click)="getDeviceDetailsById(list && list.device_id); closePopups(); showMapPopup = true">
                        <button type="button" class="transaction-submit-button">
                          <span class="text">Map</span>
                        </button>
                      </div>
                    </div>
                    <div class="buttons-div reports_search_div d-inline-block" *ngIf="list && list.loc_id == 2">
                      <div class="transactions-button-container" (click)="getDeviceDetailsById(list && list.device_id); closePopups(); showInventoryInactivePopup = true">
                        <button type="button" class="transaction-close-button">
                          <span class="text">In-Active</span>
                        </button>
                      </div>
                    </div>
                    <!--Hub location type-->
                    <div class="buttons-div reports_search_div d-inline-block margin-right-10" *ngIf="list && list.loc_id == 3">
                      <div class="transactions-button-container" (click)="getDeviceDetailsById(list && list.device_id); closePopups(); showMoveToInventoryPopup = true">
                        <button type="button" class="transaction-submit-button">
                          <span class="text">Move to Inventory</span>
                        </button>
                      </div>
                    </div>
                    <div class="buttons-div reports_search_div d-inline-block" *ngIf="list && list.loc_id == 3">
                      <div class="transactions-button-container" (click)="getDeviceDetailsById(list && list.device_id); closePopups(); showHubInactivePopup = true">
                        <button type="button" class="transaction-close-button">
                          <span class="text">In-Active</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="(NoDataMessage || noList || !displayAquDeviceOnHand || displayAquDeviceOnHand.length === 0) && !listLoader" class="noDataFoundMessage">No Data Available</div>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust loader-container">
              <div class="loader2"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Deassign Model popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showDeassignPopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">De-Assign Device</div>
                <button type="button" class="add-update-submit-button" (click)="deassignFun(device && device.id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Serial Number</mat-label>
                  <input matInput [value]="device && device.serial_number" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Hub Location</mat-label>
                  <input matInput [(ngModel)]="deviceMovement.to" name="email" placeholder="Enter Hub Location" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Date</mat-label>
                  <input matInput id="startdate" name="deassigndate" [(ngModel)]="deassigndate" autocomplete="off" placeholder="DD-MMM-YYYY" class="dateselect" readonly style="pointer-events: none;" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Reason</mat-label>
                  <textarea matInput rows="3" name="desc" [(ngModel)]="deviceMovement.comment" placeholder="Enter Reason" required></textarea>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Customer Inactive Popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showCustomerInactivePopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">Customer Device In-Active</div>
                <button type="button" class="add-update-submit-button" (click)="customerinActiveFun(device && device.id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Serial Number</mat-label>
                  <input matInput [value]="device && device.serial_number" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Date</mat-label>
                  <input matInput id="inactivedate" name="custinactive_date" [(ngModel)]="inactive_date" autocomplete="off" placeholder="DD-MMM-YYYY" class="dateselect" readonly style="pointer-events: none;" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Reason</mat-label>
                  <textarea matInput rows="3" name="custinactivedesc" [(ngModel)]="deviceMovement.comment" placeholder="Enter Reason" required></textarea>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Inventory Inactive Popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showInventoryInactivePopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">Inventory Device In-Active</div>
                <button type="button" class="add-update-submit-button" (click)="inventoryinActiveFun(device && device.id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Serial Number</mat-label>
                  <input matInput [value]="device && device.serial_number" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Date</mat-label>
                  <input matInput id="inventoryinactivedate" name="inventory_inactive_date" [(ngModel)]="inventory_inactive_date" autocomplete="off" placeholder="DD-MMM-YYYY" class="dateselect" readonly style="pointer-events: none;" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Performing By</mat-label>
                  <input matInput [(ngModel)]="loginPersonType" name="performing_by" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Reason</mat-label>
                  <textarea matInput rows="3" name="desc" [(ngModel)]="deviceMovement.comment" placeholder="Enter Reason" required></textarea>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Hub Inactive Popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showHubInactivePopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">Hub Device In-Active</div>
                <button type="button" class="add-update-submit-button" (click)="hubinActiveFun(device && device.id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Serial Number</mat-label>
                  <input matInput [value]="device && device.serial_number" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Date</mat-label>
                  <input matInput id="hubinactivedate" name="hub_inactive_date" [(ngModel)]="hub_inactive_date" autocomplete="off" placeholder="DD-MMM-YYYY" class="dateselect" readonly style="pointer-events: none;" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Reason</mat-label>
                  <textarea matInput rows="3" name="desc" [(ngModel)]="deviceMovement.comment" placeholder="Enter Reason" required></textarea>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Map Device to Business Popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showMapPopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">Map Device to Business</div>
                <button type="button" class="add-update-submit-button" (click)="mapDeviceFun(device && device.id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select Business</mat-label>
                  <mat-select [(ngModel)]="businessEntitie.id" name="business" required>
                    <mat-option value="" disabled>Select Business Name</mat-option>
                    <mat-option *ngFor="let business of businessEntities" [value]="business.id">
                      {{ business.businessName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Serial Number</mat-label>
                  <input matInput [value]="device && device.serial_number" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Date</mat-label>
                  <input matInput id="Maptodate" name="map_todate" [(ngModel)]="map_todate" autocomplete="off" placeholder="DD-MMM-YYYY" class="dateselect" readonly style="pointer-events: none;" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Comment</mat-label>
                  <textarea matInput rows="3" name="desc" [(ngModel)]="deviceMovement.comment" placeholder="Enter Comment" required></textarea>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Move to Inventory Popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showMoveToInventoryPopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">Move to Inventory</div>
                <button type="button" class="add-update-submit-button" (click)="moveToInventoryFun(device && device.id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Serial Number</mat-label>
                  <input matInput [value]="device && device.serial_number" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Hub Location</mat-label>
                  <input matInput [(ngModel)]="deviceMovement.to" name="hublocation" placeholder="Enter Hub Location" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Date</mat-label>
                  <input matInput id="movetoInventorydate" name="moveto_inventorydate" [(ngModel)]="moveto_inventorydate" autocomplete="off" placeholder="DD-MMM-YYYY" class="dateselect" readonly style="pointer-events: none;" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Reason</mat-label>
                  <textarea matInput rows="3" name="desc" [(ngModel)]="deviceMovement.comment" placeholder="Enter Reason" required></textarea>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Assign TINTO Popup -->
      <div class="dynamic-form-wrapper floating-panel" *ngIf="showAssignTintoPopup">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closePopups()" title="Close">&times;</button>
          <div class="popup-inner">
            <form novalidate>
              <div class="form-header">
                <div class="form-title">Assign TINTO Device</div>
                <button type="button" class="add-update-submit-button" (click)="assignTintoDevice(customerDevice.paired_device_id); closePopups()">
                  <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>TINTO Device Number</mat-label>
                  <mat-select [(ngModel)]="customerDevice.paired_device_id" name="pairedDevice">
                    <mat-option value="undefined" disabled>Select TINTO Device Number</mat-option>
                    <mat-option *ngFor="let tinto of nonMappedDevice && nonMappedDevice.tintoDevices" [value]="tinto.id">
                      {{ tinto.number }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
